import type { Tag } from "@taskfortress/core"
import React from "react"
import { DesktopOnly } from "../DesktopOnly"
import { MobileOnly } from "../MobileOnly"
import { TaskListDesktop } from "./TaskListDesktop"
import { TaskListMobile } from "./TaskListMobile"

interface TaskListProps {
  currentDate: string
  onCurrentDateChange: (date: string) => void
  selectedTag?: Tag | null
}

export const TaskList: React.FC<TaskListProps> = ({
  currentDate,
  onCurrentDateChange,
  selectedTag,
}) => {
  return (
    <>
      <DesktopOnly>
        <TaskListDesktop
          currentDate={currentDate}
          onCurrentDateChange={onCurrentDateChange}
          selectedTag={selectedTag}
        />
      </DesktopOnly>
      <MobileOnly>
        <TaskListMobile
          currentDate={currentDate}
          onCurrentDateChange={onCurrentDateChange}
          selectedTag={selectedTag}
        />
      </MobileOnly>
    </>
  )
}
